import React from "react";

import Styles from "./plot-legend.module.scss";

const PlotLegend = props => {
    const { video, dataScale, colors } = props;
    const { processed } = video;

    const ticks = dataScale.ticks(4).slice(1, 4);

    // TODO: doesnt handle multiple category indices properly.
    const categoryPlots = processed.plots.map((plot, index) => {
        const color = colors[index];
        const blocks = ticks.map(tick => (
            <div
                key={tick}
                className={Styles.legendBlock}
                style={{
                    backgroundColor: color,
                    opacity: dataScale(tick),
                }}
            />
        ));
        return <div className={Styles.legendRow} key={index}>{blocks}</div>;
    });

    const labels = [
        `1-${ticks[0] - 1}`,
        `${ticks[0]}-${ticks[2]}`,
        `${ticks[2] + 1}+`,
    ].map(label => <div key={label} className={Styles.legendLabel}>{label}</div>);

    return (
        <div className={Styles.plotLegend}>
            <h4>Total in Block</h4>
            <div className={Styles.legendTable}>
                <div className={Styles.legendRow}>{labels}</div>
                {categoryPlots}
            </div>
        </div>
    );
};

export default PlotLegend;



// WEBPACK FOOTER //
// ./src/components/plot-legend/plot-legend.js